import Vue from 'vue';
import { createHelpers } from 'vuex-map-fields';

import {
  USER_REQUEST,
  USER_ERROR,
  USER_SUCCESS,
  USER_CLEAR,
  USER_CHANGE_REQUEST,
} from '../actions/user';
import { AUTH_SUCCESS } from '../actions/auth';
import { HEALTH_REQUEST } from '../actions/health';
import { ROUTE_API_GET_USER } from '@/constants/apiRoutes';

const { getUserField, updateUserField } = createHelpers({
  getterType: 'getUserField',
  mutationType: 'updateUserField',
});

const state = {
  userStatus: '',
  user: {},
};

const getters = {
  getUserField,

  getUser: (state) => state.user,
  isUserLoaded: (state) => !!state.user.username,
};

const mutations = {
  updateUserField,

  [USER_CLEAR]: (state) => {
    state.userStatus = '';
    state.user = {};
  },
  [USER_REQUEST]: (state) => {
    state.userStatus = 'loading';
  },
  [USER_SUCCESS]: (state, resp) => {
    state.userStatus = 'success';
    state.user = resp.data;
  },
  [USER_CHANGE_REQUEST]: (state, data) => {
    state.userStatus = 'success';
    state.user = Object.assign(state.user, data);
  },
  [USER_ERROR]: (state) => {
    state.userStatus = 'error';
  },
};

const actions = {
  [USER_CLEAR]: ({ commit }) => {
    commit(USER_CLEAR);
  },
  [USER_REQUEST]: ({ commit, dispatch }) => {
    commit(USER_REQUEST);

    /**
     * Get user data if authenticated
     */
    return new Promise((resolve) => {
      Vue.axios
        .get(ROUTE_API_GET_USER)
        .then((response) => {
          dispatch(AUTH_SUCCESS, response);
          dispatch(HEALTH_REQUEST);
          commit(USER_SUCCESS, response);
          resolve();
        })
        .catch(() => {
          commit(USER_ERROR);
          commit(USER_CLEAR);
          resolve(); // resolve(); is okay. Promise is only used in main.js to check, if response done
        });
    });
  },

  [USER_CHANGE_REQUEST]: ({ commit }, data) => {
    commit(USER_CHANGE_REQUEST, data);
  },
};

export default {
  state,
  getters,
  actions,
  mutations,
};
